// ─── Mockup Router ──────────────────────────────────────────────────────────
// Routes to the correct mockup component based on SearchFormatType.
// Formats without a dedicated mockup show a "not available" placeholder.
// When real mockups are ready, add them here and swap the case.

import { Monitor } from 'lucide-react';
import { MSANMockup } from './MSANMockup';
import type { SearchFormatType } from '../search-config';
import { SEARCH_FORMAT_CONFIGS } from '../search-config';

function UnavailablePlaceholder({ label }: { label: string }) {
  return (
    <div className="w-full h-full flex items-center justify-center">
      <div className="flex flex-col items-center gap-4 text-center px-6">
        <div className="w-14 h-14 rounded-2xl bg-slate-100 flex items-center justify-center">
          <Monitor className="w-7 h-7 text-slate-400" />
        </div>
        <div>
          <p className="text-sm font-semibold text-slate-500">{label} Preview</p>
          <p className="text-xs text-slate-400 mt-1">Preview not supported for this format</p>
        </div>
        <div className="w-48 space-y-2 mt-2">
          <div className="h-2 bg-slate-100 rounded-full" />
          <div className="h-2 bg-slate-100 rounded-full w-3/4" />
          <div className="h-2 bg-slate-100 rounded-full w-1/2" />
        </div>
      </div>
    </div>
  );
}

export function MockupRouter({ formatType }: { formatType: SearchFormatType }) {
  const config = SEARCH_FORMAT_CONFIGS[formatType];

  switch (formatType) {
    case 'msan':
      return <MSANMockup />;
    default:
      return <UnavailablePlaceholder label={config.label} />;
  }
}
